import React from 'react';
import Spinner from 'components/UI/Spinner';
import styled from 'styled-components';
import { Space } from 'styles/themeSpaces';

const Container = styled.div<Props>`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  margin: ${({ margin, center }) => margin ? margin : `${center ? '40vh' : Space.sp4x} auto`};

`;

interface Props {
  className?: string;
  size?: number;
  margin?: string;
  center?: boolean;
  color?: string;
};

const LoadingIndicator = ({ className, size = 64, margin, center = false, color }: Props) => {
  return (
    <Container className={className} size={size} margin={margin} center={center}>
      <Spinner size={size} color={color} />
    </Container>
  );
};

export default LoadingIndicator;
